import { TUploadData } from '@entities/comment/model/types';

export const submitAdapter = ({ text, attachments }: TUploadData) => {
    const fd = new FormData();

    fd.append('text', text);
    attachments?.forEach((file) => fd.append('files[]', file));

    return fd;
};
